// src/components/AI.js

import React, { useState, useEffect } from 'react';
import './AI.css';
// It's common to use a library like axios for API calls, but fetch works great too.
// import axios from 'axios';

const AI = () => {
  // State to hold the API choice, e.g., 'openai', 'gemini'
  const [selectedApi, setSelectedApi] = useState('');

  // State to manage loading and feedback messages
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // --- API ENDPOINT (CHANGE THIS TO YOUR ACTUAL ENDPOINT) ---
  const API_ENDPOINT = '/api/v1/settings/ai'; 

  // 1. Fetch the current setting when the component loads
  useEffect(() => {
    const fetchCurrentSetting = async () => {
      setIsLoading(true);
      setError('');
      try {
        // --- Replace this with your actual API call ---
        // const response = await fetch(API_ENDPOINT);
        // if (!response.ok) throw new Error('Failed to fetch settings.');
        // const data = await response.json();
        // setSelectedApi(data.activeApi);
        
        // --- MOCK API CALL (for demonstration) ---
        // This simulates a network delay. Remove this block when you have a real API.
        console.log("Fetching current AI setting...");
        await new Promise(resolve => setTimeout(resolve, 800)); // Simulate network delay
        const mockResponse = { activeApi: 'openai' }; // Simulate response from backend
        setSelectedApi(mockResponse.activeApi);
        console.log("Current setting is:", mockResponse.activeApi);
        // --- End of Mock API Call ---

      } catch (err) {
        setError(err.message || 'Could not load the current AI setting.');
        console.error("Fetch error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCurrentSetting();
  }, []); // The empty array [] ensures this runs only once on component mount

  // 2. Handler to save the new setting to the backend
  const handleSave = async () => {
    if (!selectedApi) {
      setError('Please select an AI provider before saving.');
      return;
    }
    
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      // --- Replace this with your actual API call ---
      // const response = await fetch(API_ENDPOINT, {
      //   method: 'PUT', // or 'POST'
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ activeApi: selectedApi }),
      // });
      // if (!response.ok) throw new Error('Failed to save the setting.');
      
      // --- MOCK API CALL (for demonstration) ---
      console.log(`Saving selection: ${selectedApi}`);
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate network delay
      console.log("Save successful!");
      // --- End of Mock API Call ---

      setSuccessMessage(`Successfully set AI provider to ${selectedApi}!`);

    } catch (err) {
      setError(err.message || 'An unexpected error occurred. Please try again.');
      console.error("Save error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler for radio button changes
  const handleApiChange = (event) => {
    setSelectedApi(event.target.value);
    // Clear messages when user makes a new selection
    setError('');
    setSuccessMessage('');
  };
  
  // Display a loading indicator while fetching initial data
  if (isLoading && !successMessage) {
    return <div className="ai-container"><p>Loading AI Settings...</p></div>;
  }

  return (
    <div className="ai-container">
      <div className="ai-controls">
        <h3 className="ai-title">Select Active AI Provider</h3>
        
        <div className="radio-group">
          {/* Option 1: OpenAI */}
          <div className="radio-option">
            <input
              type="radio"
              id="api-openai"
              name="ai-provider"
              value="openai" // The value to be saved in the database
              checked={selectedApi === 'openai'}
              onChange={handleApiChange}
              disabled={isLoading}
            />
            <label htmlFor="api-openai">OpenAI</label>
          </div>

          {/* Option 2: Gemini */}
          <div className="radio-option">
            <input
              type="radio"
              id="api-gemini"
              name="ai-provider"
              value="gemini" // The value to be saved
              checked={selectedApi === 'gemini'}
              onChange={handleApiChange}
              disabled={isLoading}
            />
            <label htmlFor="api-gemini">Gemini</label>
          </div>
        </div>

        {/* Save Button */}
        <button 
          className="ai-save-button" 
          onClick={handleSave} 
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </button>

        {/* Feedback Messages */}
        {error && <p className="ai-feedback-error">{error}</p>}
        {successMessage && <p className="ai-feedback-success">{successMessage}</p>}
      </div>
    </div>
  );
};

export default AI;